import React, {useContext} from 'react'  
import CreditMemoContext from '../../../context/CreditMemoContext'
import Loader from '../../Loader/Loader';
import { useQuery } from "react-query";
import moment from "moment"; 

const CreditMemoTable = () => { 

    let {
        page,
        limit,  
        fetchData,
        markAsRecived 
    } = useContext(CreditMemoContext)  

    const {isSuccess, isLoading, isFetching, data} = useQuery( ['order', page, limit ], ({ queryKey }) => fetchData(
    ),{ keepPreviousData : true }); 

    function mark(cmId){
        markAsRecived(cmId)
    }

    return( 
        <>
        {isFetching && <Loader></Loader>}
        {isSuccess & !isFetching ? 
        <table className="table table-striped nowrap no-border-top" >
            <thead>
                <tr> 
                    <th>Credit Memo Id</th>
                    <th>Order Id</th>
                    <th>Date</th>
                    <th>Customer</th>
                    <th>Phone</th>
                    <th>Sum</th>
                    <th>Received by vendor</th>
                    <th></th>
                </tr>
            </thead>
                <tbody>
                    {data.list.length > 0 ?
                        data.list.map(row =>
                        <tr key={row.magentoInternalId}>
                            <td><div className="ml-4">{row.creditMemoId}</div></td>
                            <td>{row.orderId}</td>
                            <td>{moment(row.date).format("DD/MM/YY")}</td>
                            <td>{row.customer.shipping.name}</td>
                            <td>{row.customer.shipping.phoneNumber}</td>
                            <td>{row.sum.value} {row.sum.currency}</td>
                            <td>{row.receivedByVendor 
                            ? <span className='marker success' id={`cm-marker-${row.creditMemoId}`}></span> 
                            : <span className='marker error' id={`cm-marker-${row.creditMemoId}`}></span>
                            }</td>
                            <td><button type="button" onClick={()=>mark(row.creditMemoId.replace('S-', ''))} className="btn btn-secondary">mark as reviced</button></td>
                        </tr>
                        )
                    :
                    <tr>
                        <td colSpan={7}><span className="ro-res"> No results</span></td> 
                    </tr>
                    }
                </tbody>
        </table>
        : '' }
        </>
    )
}
export default CreditMemoTable